/**
 *
 * App-console for development and debugging
 * @name AppConsole
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['./lib/console',
            './lib/LogMessage',
            './lib/group',
            './lib/levels',
            './config'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(require('./lib/console'),
            require('./lib/LogMessage'),
            require('./lib/group'),
            require('./lib/levels'),
            require('./config'));
    } else {
        root.AppConsole = factory(root.konsole,
            root.LogMessage,
            root.group,
            root.levels,
            root.config);
    }
})(this, function (konsole, LogMessage, group, levels, config) {
    'use strict';
	/* consts */
    var ERROR 			= 'error';
    var UNDEFINED;
    var TRUE 			= true;
    var globalConfig 	= config();

    function extend (target, source, all) {
        var key;
        all = all === true;
        for (key in source) {
            if (source.hasOwnProperty(key) || all) {
                target[key] = source[key];
            }
        }
        return target;
    };

	/**
	 * Generate a wrapped call to the internal logger.
	 * Creates a LogMessage instance for output config.
	 * @private
	 *
	 * @param  {string} level Log level to use when calling the
	 *                        return function.
	 * @return {function}     Wrapped call to the internal logger. Forwards all
	 *                        arguments vie the LogMessage instance
	 */
    function bindLogger (level) {
        return function () {
            this.logMessage.log(level, arguments);
        };
    };

	/**
	 * AppConsole instance constructor.
	 * @constructor
	 * @param {object} [conf] Instance-level overrides
	 */
    function AppConsole (conf) {
        this.config(conf);
        this.logMessage = new LogMessage(this);
        this.globalConsole = GlobalAppConsole || this;
    };

    AppConsole.prototype = {
        ns: null,
        level: 'global',
        grouping: false,
        assert: function (ns, assertion) {
            if (typeof ns !== 'string') {
                arguments[1] = assertion = ns;
                arguments[0] = ns = undefined;
            }
            if (assertion != TRUE) {
                arguments[1] = 'Assertion failed';
                this.error.apply(this, arguments);
            }
        },
        debug: bindLogger('debug'),
        dir: bindLogger('dir'),
        dirxml: bindLogger(konsole.dirxml ? 'dirxml' : 'dir'),
        error: bindLogger(ERROR),
        info: bindLogger('info'),
        log: bindLogger('log'),
        time: function (message) {
            this.logMessage.time('debug', message);
        },
        timeEnd: function (message) {
            this.logMessage.timeEnd('debug', message);
        },
        trace: function () {
            this.logMessage.trace();
        },
        warn: bindLogger('warn'),
		/**
		 * Convenience check to verify that we are 'above'
		 * the level of debugging.
		 * @return {boolean} Returns true if debugging is enabled.
		 */
        isDebugEnabled: function () {
            return (levels.debug >= this.level);
        },
		/**
		 * Check the currently set logging level.
		 * @return {string} String representation of the logging level.
		 * @see  levels
		 */
        getLevel: function () {
            return this.level;
        },
        setLevel: function (level) {
            this.level = levels[level] ? level : 'none';
        },
		/**
		 * Apply optional config properties to the logger.
		 * User this to set level and grouping.
		 * @param  {object} opts Config options for the logger.
		 * @example
		 * 		Curveball.Log.config({
		 * 			level 		: "none", 	// set the log level
		 * 			grouping 	: false  	// disable grouping,
		 * 			useAlert    : true  	// enable alert
		 *   	});
		 */
        config: function (opts) {
            extend(this, opts);

            if (!this.grouping && group.current || this.level === 'none') {
                group.end(group.current);
            }
        }
    };

    var GlobalAppConsole = extend(function (props) {
        return new AppConsole(props);
    }, new AppConsole(globalConfig), true);

    GlobalAppConsole.logMessage.ctx = GlobalAppConsole;

    return GlobalAppConsole;
});
